module.exports = __webpack_public_path__ + "img/1291645304.312addec.jpg";